// extracted by mini-css-extract-plugin
module.exports = {"container":"product-form-title_container__3hfsy","title":"product-form-title_title__1FQDG","open":"product-form-title_open__Om-aw"};